import { Column, Entity } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('_search_index')
export class SearchIndexEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('varchar', { name: '_slug', length: 255 })
	public slug!: string;

	@Column('longtext', { name: '_query' })
	public query!: string;

	@Column('longtext', { name: '_fieldMapping' })
	public fieldMapping!: string;

	@Column('longtext', { name: '_displayFields' })
	public displayFields!: string;

	@Column('longtext', { name: '_fieldOptions' })
	public fieldOptions!: string;
}
